


// import React from 'react';
// import './Payment.css';

// const Payment = ({ transactions, onUpdate }) => {
//   return (
//     <div className="transaction-management">
//       <div className="list-container">
//         <h2 className="list-title">All Transactions ({transactions.length})</h2>
//         {transactions.length === 0 ? (
//           <p className="no-transactions">No transactions found.</p>
//         ) : (
//           <div className="table-container">
//             <table className="transaction-table">
//               <thead>
//                 <tr>
//                   <th>Reference</th>
//                   <th>Amount (NGN)</th>
//                   <th>Status</th>
//                   <th>Channel</th>
//                   <th>Gateway Response</th>
//                   <th>Email</th>
//                   <th>Check In</th>
//                   <th>Check Out</th>
//                   <th>Full Name</th>
//                   <th>Phone Number</th>
//                   <th>Paid At</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {transactions.map((transaction) => (
//                   <tr key={transaction._id}>
//                     <td>{transaction.reference}</td>
//                     <td>{(transaction.amount / 100).toFixed(2)}</td> {/* Convert kobo to NGN */}
//                     <td>
//                       <span
//                         className={`badge ${
//                           transaction.status === 'success'
//                             ? 'badge-success'
//                             : transaction.status === 'failed'
//                             ? 'badge-error'
//                             : 'badge-secondary'
//                         }`}
//                       >
//                         {transaction.status}
//                       </span>
//                     </td>
//                     <td>{transaction.channel || 'N/A'}</td>
//                     <td>{transaction.gatewayResponse || 'N/A'}</td>
//                     <td>{transaction.customer?.email || 'N/A'}</td>
//                     <td>
//                       {transaction.metadata
//                         ? JSON.stringify(transaction.metadata.bookingDetails.checkIn, null, 2)
//                         : 'N/A'}
//                     </td>
//                                         <td>
//                       {transaction.metadata
//                         ? JSON.stringify(transaction.metadata.bookingDetails.checkOut, null, 2)
//                         : 'N/A'}
//                     </td>
//                   <td>
//                       {transaction.metadata
//                         ? JSON.stringify(transaction.metadata.bookingDetails.firstName, null, 2)
//                         : 'N/A'}                       {transaction.metadata
//                         ? JSON.stringify(transaction.metadata.bookingDetails.lastName, null, 2)
//                         : 'N/A'}
//                     </td>
//                                         <td>
//                       {transaction.metadata
//                         ? JSON.stringify(transaction.metadata.bookingDetails.phone, null, 2)
//                         : 'N/A'} 
//                     </td>
//                     <td>
//                       {transaction.paidAt
//                         ? new Date(transaction.paidAt).toLocaleString()
//                         : 'N/A'}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default Payment;


import React, { useState } from 'react';
import './Payment.css';

const Payment = ({ transactions, onUpdate }) => {
  const [expandedTransaction, setExpandedTransaction] = useState(null);

  const toggleExpand = (id) => {
    if (expandedTransaction === id) {
      setExpandedTransaction(null);
    } else {
      setExpandedTransaction(id);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  };

  const formatBookingDetail = (detail) => {
    if (!detail) return 'N/A';
    // Remove quotes from JSON stringified values
    return String(detail).replace(/"/g, '');
  };

  return (
    <div className="transaction-management">
      <div className="list-container">
        <h2 className="list-title">All Transactions ({transactions.length})</h2>
        
        {transactions.length === 0 ? (
          <div className="empty-state">
            <p>No transactions found.</p>
          </div>
        ) : (
          <>
            {/* Desktop Table View */}
            <div className="table-container desktop-view">
              <table className="transaction-table">
                <thead>
                  <tr>
                    <th>Reference</th>
                    <th>Amount (₦)</th>
                    <th>Status</th>
                    <th>Channel</th>
                    <th>Gateway Response</th>
                    <th>Email</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Full Name</th>
                    <th>Phone Number</th>
                    <th>Paid At</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((transaction) => (
                    <tr key={transaction._id}>
                      <td data-label="Reference">{transaction.reference}</td>
                      <td data-label="Amount">{(transaction.amount / 100).toFixed(2)}</td>
                      <td data-label="Status">
                        <span
                          className={`badge ${
                            transaction.status === 'success'
                              ? 'badge-success'
                              : transaction.status === 'failed'
                              ? 'badge-error'
                              : 'badge-secondary'
                          }`}
                        >
                          {transaction.status}
                        </span>
                      </td>
                      <td data-label="Channel">{transaction.channel || 'N/A'}</td>
                      <td data-label="Gateway Response">{transaction.gatewayResponse || 'N/A'}</td>
                      <td data-label="Email">{transaction.customer?.email || 'N/A'}</td>
                      <td data-label="Check In">
                        {transaction.metadata
                          ? formatBookingDetail(transaction.metadata.bookingDetails?.checkIn)
                          : 'N/A'}
                      </td>
                      <td data-label="Check Out">
                        {transaction.metadata
                          ? formatBookingDetail(transaction.metadata.bookingDetails?.checkOut)
                          : 'N/A'}
                      </td>
                      <td data-label="Full Name">
                        {transaction.metadata
                          ? `${formatBookingDetail(transaction.metadata.bookingDetails?.firstName || '')} ${formatBookingDetail(transaction.metadata.bookingDetails?.lastName || '')}`
                          : 'N/A'}
                      </td>
                      <td data-label="Phone">
                        {transaction.metadata
                          ? formatBookingDetail(transaction.metadata.bookingDetails?.phone)
                          : 'N/A'}
                      </td>
                      <td data-label="Paid At">
                        {formatDate(transaction.paidAt)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile Card View */}
            <div className="mobile-view">
              {transactions.map((transaction) => (
                <div 
                  key={transaction._id} 
                  className={`transaction-card ${expandedTransaction === transaction._id ? 'expanded' : ''}`}
                  onClick={() => toggleExpand(transaction._id)}
                >
                  <div className="card-header">
                    <div className="card-ref-amount">
                      <h3 className="card-reference">{transaction.reference}</h3>
                      <p className="card-amount">₦{(transaction.amount / 100).toFixed(2)}</p>
                    </div>
                    <span
                      className={`badge ${
                        transaction.status === 'success'
                          ? 'badge-success'
                          : transaction.status === 'failed'
                          ? 'badge-error'
                          : 'badge-secondary'
                      }`}
                    >
                      {transaction.status}
                    </span>
                  </div>

                  <div className="card-summary">
                    <p className="card-email">{transaction.customer?.email || 'No email'}</p>
                    <p className="card-date">{formatDate(transaction.paidAt)}</p>
                  </div>

                  {expandedTransaction === transaction._id && (
                    <div className="card-details">
                      <div className="detail-row">
                        <span className="detail-label">Channel:</span>
                        <span className="detail-value">{transaction.channel || 'N/A'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Gateway Response:</span>
                        <span className="detail-value">{transaction.gatewayResponse || 'N/A'}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Check In:</span>
                        <span className="detail-value">
                          {transaction.metadata
                            ? formatBookingDetail(transaction.metadata.bookingDetails?.checkIn)
                            : 'N/A'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Check Out:</span>
                        <span className="detail-value">
                          {transaction.metadata
                            ? formatBookingDetail(transaction.metadata.bookingDetails?.checkOut)
                            : 'N/A'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Full Name:</span>
                        <span className="detail-value">
                          {transaction.metadata
                            ? `${formatBookingDetail(transaction.metadata.bookingDetails?.firstName || '')} ${formatBookingDetail(transaction.metadata.bookingDetails?.lastName || '')}`
                            : 'N/A'}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Phone:</span>
                        <span className="detail-value">
                          {transaction.metadata
                            ? formatBookingDetail(transaction.metadata.bookingDetails?.phone)
                            : 'N/A'}
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="card-expand-indicator">
                    {expandedTransaction === transaction._id ? '▲ Less details' : '▼ More details'}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Payment;